const environment = {
  API: `${process.env.REACT_APP_API_URL}api`,
  SERVER: process.env.REACT_APP_API_URL,
};
export default environment;